import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class UserStateService {
    private _employeeCode: string | null = null;
    private _assignmentId: string | null = null;
    private _employeeId: string | null = null;

    // EmployeeCode
    set employeeCode(code: string) {
        //console.log('[UserStateService] Set employeeCode:', code);
        this._employeeCode = code;
    }

    get employeeCode(): string | null {
        // console.log('[UserStateService] Get employeeCode:', this._employeeCode);
        return this._employeeCode;
    }

    // AssignmentId
    set assignmentId(id: string) {
        //console.log('[UserStateService] Set assignmentId:', id);
        this._assignmentId = id;
    }

    get assignmentId(): string | null {
        //console.log('[UserStateService] Get assignmentId:', this._assignmentId);
        return this._assignmentId;
    }

    // EmployeeId
    set employeeId(id: string) {
        //console.log('[UserStateService] Set employeeId:', id);
        this._employeeId = id;
    }

    get employeeId(): string | null {
        //console.log('[UserStateService] Get employeeId:', this._employeeId);
        return this._employeeId;
    }

    clear() {
        // console.log('[UserStateService] Clear all state');
        this._employeeCode = null;
        this._assignmentId = null;
        this._employeeId = null;
    }
}
